export default "__VITE_ASSET__Ck8dAOhO__"